export default __webpack_public_path__ + "static/media/icn_biostrap.e17de479.svg";